import React, { useState } from "react";
import styles from "./CluesoAuth.module.scss";
import { Button, Input } from "antd";
import warning from "../Icons/warning.svg";

export const CluseoAuthContent = () => {
  const [domain, setDomain] = useState(null);
  const [isError, setError] = useState({
    error: false,
    message: "",
  });
  const query = new URLSearchParams(window.location.search);
  const redirect_uri = query.get("location");
  const urlFragment = window.location.hash;
  const domainUrl = window.location.host.split(".").slice(1, 3).join(".");
  const currentUrl = window.location.host.split("//")[0];
  const isLocalHost = currentUrl.indexOf("localhost");
  const combinedEncodedUrl = `${redirect_uri}${urlFragment}`;


  const redirectToDomain = () => {
    if (!domain) {
      setError({
        error: true,
        message: "Domain can't be empty",
      });
      return;
    }
    if (isLocalHost !== -1) {
      window.open(
        `http://localhost:3001/?redirect_uri=${encodeURIComponent(combinedEncodedUrl)}`,
        "_self",
      );
      return;
    }
    window.open(
      `https://${domain}.${domainUrl}/?redirect_uri=${combinedEncodedUrl}`,
      "_self",
    );
  };

  const handleDomainUrl = (value) => {
    if (value) {
      if (isError.error) {
        setError({
          error: false,
          message: "",
        });
      }
      setDomain(value);
    } else {
      setDomain(value);
    }
  };
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.signInWrapper}>
        <div className={styles.headingWrapper}>
          <span className={styles.heading}>Help Center Sign In</span>
          <span className={styles.instruction}>
            Enter your custom domain name to sign in
          </span>
        </div>
        <div className={styles.formWrapper}>
          <span className={styles.customDomainText}>Custom Domain</span>
          <div className={styles.customDomainContent}>
            <Input
              type="text"
              className={styles.domainInput}
              placeholder="your_company_name"
              onChange={(e) => {
                handleDomainUrl(e.target.value);
              }}
              onPressEnter={() => {
                redirectToDomain();
              }}
            />
            <div className={styles.cloudeagleDomain}>
              <span>.{domainUrl || "cloudeagle.ai"}</span>
            </div>
          </div>
          {isError.error && (
            <div className={styles.errorMsg}>
              <img src={warning} width="18" alt="" />
              <span>{isError.message}</span>
            </div>
          )}

          <Button className={styles.continueBlueBtn} onClick={redirectToDomain}>
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
